import { TranslatedTerms } from "../../globals/TranslatedTerms";
import { lang } from "../../globals/Translations";
import { DefaultId } from "../../shared/Globals";
import { TranslatedContent } from "../../shared/Language";

type ContentLabel = {
    title: string,
    label: string
}

type ProjectContentLabelMap = {
    investment: ContentLabel,
    developer: ContentLabel,
    projectcompany: ContentLabel,
    vault: ContentLabel,
    crowdinvestor: ContentLabel,
    bank: ContentLabel,
    fb: ContentLabel,
    project: ContentLabel,
    review: ContentLabel,
    sold: ContentLabel,
    payback: ContentLabel,
    bankreturn: ContentLabel,
    crowdinvestorreturn: ContentLabel,
    developerreturn: ContentLabel,
    economy: ContentLabel,
    risks: ContentLabel

}

const generateContentLabel = (title:string, label:string) => ({title: lang(title), label: lang(label)}) 


const mapDetailsLabels:ProjectContentLabelMap = {
    investment: generateContentLabel(TranslatedTerms.INVESTMENT,TranslatedTerms.INVESTMENT_PROJECT_LABEL_DESCRIPTION),
    developer: generateContentLabel(TranslatedTerms.BUILDING_DEVELOPER,TranslatedTerms.BUILDING_DEVELOPER_PROJECT_LABEL_DESCRIPTION),
    projectcompany: generateContentLabel(TranslatedTerms.PROJECT_COMPANY,TranslatedTerms.PROJECT_COMPANY_PROJECT_LABEL_DESCRIPTION),
    vault: generateContentLabel(TranslatedTerms.DEPOSIT_ACCOUNT,TranslatedTerms.DEPOSIT_ACCOUNT_PROJECT_LABEL_DESCRIPTION),
    crowdinvestor: generateContentLabel(TranslatedTerms.CROWDINVESTOR,TranslatedTerms.CROWDINVESTOR_PROJECT_LABEL_DESCRIPTION),
    bank: generateContentLabel(TranslatedTerms.BANK_FINANCEING,TranslatedTerms.BANK_FINANCEING_PROJECT_LABEL_DESCRIPTION),
    fb: generateContentLabel("Fundbricks.com",TranslatedTerms.FUNDBRICKS_PROJECT_LABEL_DESCRIPTION),
    project: generateContentLabel(TranslatedTerms.PROJECT,TranslatedTerms.PROJECT_PROJECT_LABEL_DESCRIPTION),
    review: generateContentLabel(TranslatedTerms.CONSTRUCTION_EXPERT,TranslatedTerms.CONSTRUCTION_EXPERT_PROJECT_LABEL_DESCRIPTION),
    sold: generateContentLabel(TranslatedTerms.SALES_PERIOD,TranslatedTerms.SALES_PERIOD_PROJECT_LABEL_DESCRIPTION),
    payback: generateContentLabel(TranslatedTerms.RETURN_PAYMENT,TranslatedTerms.RETURN_PAYMENT_PROJECT_LABEL_DESCRIPTION),
    bankreturn: generateContentLabel(TranslatedTerms.BANK_RETURN_PAYMENT,TranslatedTerms.BANK_RETURN_PAYMENT_PROJECT_LABEL_DESCRIPTION),
    crowdinvestorreturn: generateContentLabel(TranslatedTerms.CROWDINVESTOR_RETURN_PAYMENT,TranslatedTerms.CROWDINVESTOR_RETURN_PAYMENT_PROJECT_LABEL_DESCRIPTION),
    developerreturn: generateContentLabel(TranslatedTerms.DEVELOPER_RETURN_PAYMENT,TranslatedTerms.DEVELOPER_RETURN_PAYMENT_PROJECT_LABEL_DESCRIPTION),
    economy: generateContentLabel(TranslatedTerms.ECONOMY,TranslatedTerms.ECONOMY_PROJECT_LABEL_DESCRIPTION),
    risks: generateContentLabel(TranslatedTerms.RISK,TranslatedTerms.RISK_PROJECT_LABEL_DESCRIPTION)
}


export default mapDetailsLabels